module.exports = __webpack_public_path__ + "static/media/paper-plane.2c9553ca.svg";